import { captureException } from '@sentry/node';
import axios from 'axios';
import { stringify } from 'qs';

const discoveryRequester = axios.create({
    baseURL: 'https://discovery-lk.ertelecom.ru/',
});

export async function getTokenDiscovery({ domain, accessToken }) {
    const config = {
        params: {
            region: domain,
            access_token: accessToken,
        },
    };
    const { default: md5 } = await import('blueimp-md5');

    return discoveryRequester.post('er/ssoauth/auth/by_access_token', null, config)
        .then(response => {
            const ssoKey = response.data?.sso;

            if (!ssoKey) {
                return null;
            }

            const time = (new Date()).getTime(),
                signature = md5(
                    'client_ider_web_cabinetsso_key' +
                    ssoKey +
                    'sso_systemertimestamp' +
                    time +
                    'gQpCQAsJcUO67Xnp8hI9BPjO0UdD_43hNIcpgUrGX5U=',
                ),
                params = {
                    'client_id': 'er_web_cabinet',
                    'sso_key': ssoKey,
                    'sso_system': 'er',
                    'signature': signature,
                    'timestamp': time,
                };

            const config = {
                params: params,
                paramsSerializer: params => {
                    return stringify(params);
                },
            };

            return discoveryRequester.get('token/subscriber/by_sso', config);
        })
        .then(response => {
            return response.data?.token;
        })
        .catch((e) => {
            captureException(e);
            return null;
        });
}

export function getDevices({ accessTokenWatchEverywhere }) {
    const config = {
        params: {
            auth_token: accessTokenWatchEverywhere,
        },
    };

    return discoveryRequester.get('er/multiscreen/devices', config)
        .then(response => {
            if (+response.data?.result && Array.isArray(response.data?.devices)) {
                return response.data.devices;
            }
            return [];
        })
        .catch((e) => {
            captureException(e);
            return [];
        });
}

export function removeDevice({ accessTokenWatchEverywhere, deviceId }) {
    const MESSAGE_ERROR = 'Не удалось выполнить действие. Пожалуйста, попробуйте позднее.';

    const config = {
        params: {
            device_id: deviceId,
            auth_token: accessTokenWatchEverywhere,
        },
    };

    return discoveryRequester.post('er/multiscreen/device/unbind', null, config)
        .then(response => {
            return {
                isDeleted: Boolean(+response.data.result),
                message: response.data.error?.message_rus || MESSAGE_ERROR,
            };
        }).catch((e) => {
            captureException(e);
            return {
                isDeleted: false,
                message: MESSAGE_ERROR,
            };
        });
}
